// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AngleDownL1Nav: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 10 6" width={width} height={height}>
            <path
                fill="currentColor"
                d="M5.087 5.505c.159.162.42.162.578 0l4.092-4.169a.424.424 0 0 0 0-.589.405.405 0 0 0-.578 0L5.376 4.622 1.573.747a.405.405 0 0 0-.578 0 .424.424 0 0 0 0 .59z"
            />
        </svg>
    );
};

export default React.memo(AngleDownL1Nav);
